const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BASE_URL = BACKEND_URL || '';

// EmailJS config
export const EMAILJS_CONFIG = {
  service_id: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  template_id: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  public_key: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
};

export const CONTACT_INFO = {
  phone: '+90 546 573 99 33',
  whatsapp: '905465739933',
  address: 'Cevizlidere mahallesi, Mevlana Bulvarı, Yıldırım Kule 5. Kat No:221/15, Balgat-Ankara, 06520',
  hours: 'Salı - Cuma: 10:00 - 18:00',
  hoursSaturday: 'Cumartesi: 10:00 - 18:00',
  hoursSunday: 'Pazar: Kapalı',
  mapLink: 'https://www.google.com/maps/place/YILDIRIM+KULE/@39.8820705,32.8127704,19.5z/data=!4m10!1m2!2m1!1zQ2V2aXpsaWRlcmUgbWFoYWxsZXNpLCBNZXZsYW5hIEJ1bHZhcsSxLCBZxLFsZMSxcsSxbSBLdWxlIE5vOjIyMS8xMTU!3m6!1s0x14d345f0a9aacc8d:0xec882979747ef3b8!8m2!3d39.8821368!4d32.8127235!15sCkRDZXZpemxpZGVyZSBtYWhhbGxlc2ksIE1ldmxhbmEgQnVsdmFyxLEsIFnEsWxkxLFyxLFtIEt1bGUgTm86MjIxLzExNVpEIkJjZXZpemxpZGVyZSBtYWhhbGxlc2kgbWV2bGFuYSBidWx2YXLEsSB5xLFsZMSxcsSxbSBrdWxlIG5vIDIyMSAxMTWSARBjb3Jwb3JhdGVfb2ZmaWNlmgFEQ2k5RFFVbFJRVU52WkVOb2RIbGpSamx2VDIwMWNtSnNVbE5hV0VwUVYyeHZkMXBzU2pSUk0yUlRWbXhrY1dWRlJSQULgAQD6AQQIABBD!16s%2Fg%2F11bycl06k5?entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D',
  email: 'sadedusun@gmail.com'
};

export const SOCIAL_LINKS = {
  youtube: 'https://www.youtube.com/@dr.niluferyldrmlasadedusun9263',
  instagram: 'https://www.instagram.com/profdrniluferyildirim/',
  facebook: 'https://www.facebook.com/sadedusuncom/?locale=tr_TR'
};

export const DOCTOR_IMAGE = 'https://customer-assets.emergentagent.com/job_dr-nilufershop/artifacts/rd2kgze0_image.png';

export const PROCESS_STEPS = [
  {
    step: 1,
    title: 'İlk Görüşme',
    description: 'Detaylı sağlık geçmişiniz, yaşam tarzınız ve şikayetleriniz dinlenerek kapsamlı bir değerlendirme yapılır.',
    icon: 'MessageCircle'
  },
  {
    step: 2,
    title: 'Analiz ve Yol Haritası',
    description: 'İleri düzey laboratuvar testleri, hormon paneli ve gerekli analizler ile mevcut durumunuz detaylı şekilde incelenir.',
    icon: 'ClipboardList'
  },
  {
    step: 3,
    title: 'Uygulama ve Takip',
    description: 'Test sonuçlarınıza göre size özel beslenme, yaşam tarzı, takviye ve tedavi planınız oluşturulur.',
    icon: 'FileText'
  },
  {
    step: 4,
    title: 'Koruma ve Optimizasyon',
    description: 'Düzenli kontrol görüşmeleri ile planınız güncellenir, ilerlemeniz izlenir ve gerekli optimizasyonlar yapılır.',
    icon: 'TrendingUp'
  }
];
